import { IForm } from '../interfaces/IForm';

export class Form implements IForm {
    formName: string = null;
    url: string = null;
    formInstanceStatus: string = null;

    constructor(data: any) {
        this.url = data.url;
        this.formName = data.formName;
        this.formInstanceStatus = data.formInstanceStatus;
    }
}
